import { effect } from "@lit-labs/preact-signals";
import { draft, launch } from ".";
let stop = null;
let timer = null;
// Guard: when we write draft.value ourselves (saveStatus transitions), skip re-entrancy
let writing = false;
let currentScenarioId = null;
export function startAutosave(scenarioId, save, debounceMs = 2000) {
    stopAutosave();
    currentScenarioId = scenarioId;
    stop = effect(() => {
        const d = draft.value;
        // Not yet initialised — don't subscribe until draft exists
        if (!d)
            return;
        // Skip effect reactions triggered by our own saveStatus writes
        if (writing)
            return;
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => {
            void (async () => {
                try {
                    writing = true;
                    draft.value = { ...draft.value, saveStatus: "saving" };
                    writing = false;
                    const r = await save(scenarioId, draft.value);
                    writing = true;
                    draft.value = { ...draft.value, saveStatus: "saved", lastSavedAt: r.saved_at };
                    writing = false;
                }
                catch {
                    writing = true;
                    draft.value = { ...draft.value, saveStatus: "error" };
                    writing = false;
                }
            })();
        }, debounceMs);
    });
    window.addEventListener("visibilitychange", flushOnHide);
    window.addEventListener("beforeunload", flushBeforeUnload);
}
/**
 * Best-effort synchronous persist of the current draft when there was a
 * pending debounced save still waiting to fire. sendBeacon can't carry an
 * Authorization header and the save endpoint requires the session bearer
 * token, so a keepalive fetch is used instead — it survives page unload the
 * same way sendBeacon does, but can still authenticate.
 */
function flushPending() {
    const hadPending = timer !== null;
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    if (!hadPending || !currentScenarioId || !draft.value)
        return;
    const token = launch.value?.sessionToken;
    void fetch(`/case/${currentScenarioId}/save`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(draft.value),
        keepalive: true,
    }).catch(() => { });
}
function flushOnHide() {
    if (document.hidden)
        flushPending();
}
function flushBeforeUnload() {
    flushPending();
}
export function stopAutosave() {
    if (stop) {
        stop();
        stop = null;
    }
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    writing = false;
    currentScenarioId = null;
    window.removeEventListener("visibilitychange", flushOnHide);
    window.removeEventListener("beforeunload", flushBeforeUnload);
}
